import type { SessionCookiePayload } from "@/lib/session/types";

// NOTE: cross-component contract shared with the scirix CLI (reads this cookie
// via `scirix auth browser-state`). Renaming requires a coordinated CLI release,
// so the value stays "mercenary.session" until that infra pass.
export const SESSION_COOKIE_NAME = "mercenary.session";
export const SESSION_EXPIRY_BUFFER_MS = 2 * 60 * 1000; // 2 minutes

export function serializeSessionCookie(payload: SessionCookiePayload): string {
  return encodeURIComponent(JSON.stringify(payload));
}

export function deserializeSessionCookie(value?: string | null): SessionCookiePayload | null {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(decodeURIComponent(value)) as SessionCookiePayload;
  } catch {
    return null;
  }
}

export function isSessionExpired(payload?: SessionCookiePayload | null): boolean {
  if (!payload) {
    return true;
  }

  const expiresAt = Date.parse(payload.expiresAt);
  if (Number.isNaN(expiresAt)) {
    return true;
  }

  return expiresAt - SESSION_EXPIRY_BUFFER_MS <= Date.now();
}
